import type { ArticleManager } from '@easterngraphics/wcf/modules/cf';
import type App from '@egr/xbox/base-app/App';
import type { ProgressCallbacks } from '@egr/xbox/egr-gui-dialogs/utils/LoadingUtils';

import { isNullOrEmpty } from '@easterngraphics/wcf/modules/utils/string';

export function progressNext(format: string | undefined, progressCallbacks: ProgressCallbacks | undefined): void {
    if (isNullOrEmpty(format) || progressCallbacks?.getMessage == null) {
        return progressCallbacks?.nextStep();
    }
    return progressCallbacks?.nextStep(progressCallbacks.getMessage(format));
}

export async function updateArticle(app: App, articleManager: ArticleManager): Promise<boolean> {
    const { exportManager } = app;

    if (
        app.sceneManager.elementsInfo.snapshot.mainElements.length > 0 &&
        !(await exportManager.exportPreCheck(articleManager, { showMessage: true }))
    ) {
        return false;
    }

    return true;
}

export async function updateBasket(): Promise<boolean> {
    console.warn('update basket callback missing');
    return false;
}